// extracted by mini-css-extract-plugin
export default {"container":"knowledge-of-games_container__Q9+SQ","imgWrapper":"knowledge-of-games_imgWrapper__CSmiw","ipadArt":"knowledge-of-games_ipadArt__wuAdQ"};